<div class="ml-5">
  <p id="gestion-des-packages" class="titre1 m-4">{{ 'PACKAGES_PERSO_MANAGEMENT.TITLE' | translate }}
    <mat-icon
    class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-2 float-right">settings_cinematic_blur</mat-icon>
  </p>

  <div class="hidden md:block overflow-x-auto">
    @if (isLoading) {
      <div class="flex justify-center items-center h-64">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    }

    @if (!isLoading) {
      <div class="flex justify-between items-center mb-3">
        <div class="inline-flex rounded-md shadow-sm" role="group">
          <button type="button"
            [ngClass]="{'bg-red-600 text-white': filter === 'all', 'bg-gray-200 text-gray-700': filter !== 'all'}"
            (click)="setFilter('all')"
            class="px-4 py-2 text-sm font-medium rounded-l-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none">
            {{ 'PACKAGES_PERSO_MANAGEMENT.SHOW_ALL' | translate }}
          </button>
          <button type="button"
            [ngClass]="{'bg-red-600 text-white': filter === 'active', 'bg-gray-200 text-gray-700': filter !== 'active'}"
            (click)="setFilter('active')"
            class="px-4 py-2 text-sm font-medium focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none">
            {{ 'PACKAGES_PERSO_MANAGEMENT.ACTIVE' | translate }}
          </button>
          <button type="button"
            [ngClass]="{'bg-red-600 text-white': filter === 'inactive', 'bg-gray-200 text-gray-700': filter !== 'inactive'}"
            (click)="setFilter('inactive')"
            class="px-4 py-2 text-sm font-medium focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none">
            {{ 'PACKAGES_PERSO_MANAGEMENT.INACTIVE' | translate }}
          </button>
          <button type="button"
            [ngClass]="{'bg-red-600 text-white': filter === 'draft', 'bg-gray-200 text-gray-700': filter !== 'draft'}"
            (click)="setFilter('draft')"
            class="px-4 py-2 text-sm font-medium rounded-r-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none">
            {{ 'PACKAGES_PERSO_MANAGEMENT.STATUS_DRAFT' | translate }}
          </button>
        </div>
        <div class="items-end justify-end mb-3">
          <button (click)="openAddPackage()" [disabled]="estCreationBloquee"
            [matTooltip]="obtenirTooltipCreation()" [matTooltipDisabled]="!estCreationBloquee"
            class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed">
            {{ 'PACKAGES_PERSO_MANAGEMENT.CREATE_PACKAGE' | translate }}
          </button>
        </div>
      </div>
      <div class="flex items-end justify-end mb-4 gap-3">
        <mat-select [(ngModel)]="selectedEntities" (selectionChange)="applyFilters()" multiple
          placeholder="{{ 'PACKAGES_PERSO_MANAGEMENT.ALL_ENTITIES' | translate }}"
          class="w-3/5 h-8 max-w-[300px] border border-gray-300 rounded-md px-3 py-1" panelWidth="300"
          panelHeight="100">
          <mat-option>
            <ngx-mat-select-search [formControl]="entityFilterCtrl"
              [placeholderLabel]="'PACKAGES_PERSO_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'PACKAGES_PERSO_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          @for (entity of filteredEntities | async; track entity) {
            <mat-option [value]="entity">
              {{entity}}
            </mat-option>
          }
        </mat-select>
        <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
          placeholder="{{ 'PACKAGES_PERSO_MANAGEMENT.SEARCH' | translate }}..."
          class="h-8 w-46 rounded-md border-w-2 border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
          <button mat-icon-button (click)="resetFilters()" class="h-1/12 w-8 bg-white-200 text-white-600 rounded">
            <mat-icon>restore</mat-icon>
          </button>
        </div>
        <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo"
          (matSortChange)="sortDataChange($event)">
          <ng-container matColumnDef="nom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell w-2/5 px-4 py-2"> {{
            'PACKAGES_PERSO_MANAGEMENT.NAME' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="hidden md:table-cell w-2/5 px-4 py-2 border-b">
              {{ getNomLocalise(element) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="entreprise">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell w-2/5 px-4 py-2">{{
            'PACKAGES_PERSO_MANAGEMENT.ENTITY' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="hidden md:table-cell w-2/5 px-4 py-2 border-b">
              {{obtenirNomEntites(element.entiteIds).join(', ')}}
            </td>
          </ng-container>
          <ng-container matColumnDef="statut">
            <th mat-header-cell *matHeaderCellDef class="table-cell w-1/6 px-4 py-2">{{
            'PACKAGES_PERSO_MANAGEMENT.STATUS' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/6 px-4 py-2 border-b text-left">
              {{ element.isDraft ? ('PACKAGES_PERSO_MANAGEMENT.STATUS_DRAFT' | translate) : element.actif ?
              ('PACKAGES_PERSO_MANAGEMENT.ACTIVE' | translate) : ('PACKAGES_PERSO_MANAGEMENT.INACTIVE' | translate) }}
            </td>
          </ng-container>
          <ng-container matColumnDef="dateCreation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              class="table-cell w-1/4 min-w-[140px] px-4 py-2 whitespace-nowrap">{{
            'PACKAGES_PERSO_MANAGEMENT.CREATION_DATE' | translate }}</th>
            <td mat-cell *matCellDef="let element"
              class="table-cell w-1/4 min-w-[140px] px-4 py-2 border-b text-left whitespace-nowrap">
              {{element.dateCreation | date:'yyyy-MM-dd'}}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="w-1/20 px-2 py-1">{{ 'PACKAGES_PERSO_MANAGEMENT.ACTIONS' |
            translate }}</th>
            <td mat-cell *matCellDef="let element; let i = index" class="px-2 py-1 text-center">
              <div class="menu-container">
                <button (click)="toggleMenu(i)"
                  class="bg-grey-500 hover:bg-grey-700 font-bold py-2 px-4 border-none hover:text-red-700 transform scale-90 sm:scale-100">
                  <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                </button>
                @if (element.isMenuOpen) {
                  <div
                    class="absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
                    <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                      <a href="javascript:void(0)"
                        [class]="element.estLegacy ? 'block px-4 py-2 text-sm text-gray-400 cursor-not-allowed no-underline' : 'block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline'"
                        [matTooltip]="element.estLegacy ? ('PACKAGES_PERSO_MANAGEMENT.EDIT_DISABLED_LEGACY_TOOLTIP' | translate) : ''"
                        role="menuitem"
                        (click)="element.estLegacy ? null : openEditPackage(element)">
                        {{ 'PACKAGES_PERSO_MANAGEMENT.EDIT' | translate }}
                      </a>
                    </div>
                    <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                      <a href="javascript:void(0)"
                        [class]="estActivationBloquee(element) ? 'block px-4 py-2 text-sm text-gray-400 cursor-not-allowed no-underline' : 'block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline'"
                        [matTooltip]="obtenirTooltipActivation(element)"
                        [matTooltipDisabled]="!estActivationBloquee(element)"
                        role="menuitem"
                        (click)="estActivationBloquee(element) ? null : togglePackageActivation(element.scormPackageId, element.actif)">
                        {{ element.actif ? ('PACKAGES_PERSO_MANAGEMENT.DEACTIVATE' | translate) :
                        ('PACKAGES_PERSO_MANAGEMENT.ACTIVATE' | translate) }}
                      </a>
                    </div>
                    <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                      <a href="javascript:void(0)"
                        class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 no-underline"
                        role="menuitem" (click)="openDeleteDialog(element.scormPackageId)">
                        {{ 'TAGS_MANAGEMENT.DELETE' | translate }}
                      </a>
                    </div>
                  </div>
                }
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns;" [ngClass]="{'ligne-gray': !element.estActif}">
          </tr>
        </table>
        @if (dataSource.filteredData.length === 0) {
          <div class="text-center mt-2 text-gray-500">
            {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
          </div>
        }
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
          (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
        </mat-paginator>
      }
    </div>

    <div class="md:hidden space-y-4">
      @if (isLoading) {
        <div class="flex justify-center items-center h-64">
          <mat-spinner color="accent"></mat-spinner>
        </div>
      }

      @if (!isLoading) {
        <div class="inline-flex rounded-md shadow-sm" role="group">
          <button type="button"
            [ngClass]="{'bg-red-600 text-white': filter === 'all', 'bg-gray-200 text-gray-700': filter !== 'all'}"
            class="px-4 py-2 text-sm font-medium rounded-l-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            (click)="setFilter('all')">
            {{ 'PACKAGES_PERSO_MANAGEMENT.SHOW_ALL' | translate }}
          </button>
          <button type="button"
            [ngClass]="{'bg-red-600 text-white': filter === 'active', 'bg-gray-200 text-gray-700': filter !== 'active'}"
            class="px-4 py-2 text-sm font-medium focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            (click)="setFilter('active')">
            {{ 'PACKAGES_PERSO_MANAGEMENT.ACTIVE' | translate }}
          </button>
          <button type="button"
            [ngClass]="{'bg-red-600 text-white': filter === 'inactive', 'bg-gray-200 text-gray-700': filter !== 'inactive'}"
            class="px-4 py-2 text-sm font-medium focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            (click)="setFilter('inactive')">
            {{ 'PACKAGES_PERSO_MANAGEMENT.INACTIVE' | translate }}
          </button>
          <button type="button"
            [ngClass]="{'bg-red-600 text-white': filter === 'draft', 'bg-gray-200 text-gray-700': filter !== 'draft'}"
            class="px-4 py-2 text-sm font-medium rounded-r-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            (click)="setFilter('draft')">
            {{ 'PACKAGES_PERSO_MANAGEMENT.STATUS_DRAFT' | translate }}
          </button>
        </div>
        <mat-form-field class="w-full">
          <mat-label>{{ 'PACKAGES_PERSO_MANAGEMENT.ALL_ENTITIES' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedEntities" (selectionChange)="applyFilters()" multiple>
            <mat-option>
              <ngx-mat-select-search [formControl]="entityFilterCtrl"
                [placeholderLabel]="'PACKAGES_PERSO_MANAGEMENT.SEARCH' | translate"
                [noEntriesFoundLabel]="'PACKAGES_PERSO_MANAGEMENT.NO_RESULTS' | translate">
              </ngx-mat-select-search>
            </mat-option>
            @for (entity of filteredEntities | async; track entity) {
              <mat-option [value]="entity">
                {{entity}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="relative">
          <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
            placeholder="{{ 'PACKAGES_PERSO_MANAGEMENT.SEARCH' | translate }}..."
            class="w-full px-3 py-2 border rounded-lg text-gray-700 focus:outline-none focus:border-blue-500" />
          </div>
          <div class="flex justify-end mb-4">
            <button (click)="openAddPackage()" [disabled]="estCreationBloquee"
              [matTooltip]="obtenirTooltipCreation()" [matTooltipDisabled]="!estCreationBloquee"
              class="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded disabled:opacity-50 disabled:cursor-not-allowed">
              {{ 'PACKAGES_PERSO_MANAGEMENT.CREATE_PACKAGE' | translate }}
            </button>
          </div>
          @for (package of filteredPackages; track package) {
            <div
              class="p-4 rounded-lg shadow mb-4 bg-white dark:bg-grayNovo text-black dark:text-white">
              <div class="flex justify-between items-center">
                <h3 class="text-black dark:text-white font-semibold text-lg">
                  {{getNomLocalise(package) || '[vide]'}}
                </h3>
                <div class="flex space-x-2">
                  <button
                    [disabled]="package.estLegacy"
                    [class]="package.estLegacy ? 'bg-gray-400 text-gray-600 font-bold py-1 px-2 rounded cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded'"
                    [matTooltip]="package.estLegacy ? ('PACKAGES_PERSO_MANAGEMENT.EDIT_DISABLED_LEGACY_TOOLTIP' | translate) : ''"
                    (click)="package.estLegacy ? null : openEditPackage(package)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button (click)="openDeleteDialog(package.scormPackageId)"
                    class="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 rounded">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
              <div class="mt-2 space-y-2">
                <p><strong>{{ 'PACKAGES_PERSO_MANAGEMENT.ENTITY' | translate }}:</strong>
              {{obtenirNomEntites(package.entiteIds).join(', ')}}</p>
              <p><strong>{{ 'PACKAGES_PERSO_MANAGEMENT.CREATION_DATE' | translate }}:</strong> {{package.dateCreation |
            date:'yyyy-MM-dd'}}</p>
            <div class="mt-2">
              <strong>{{ 'PACKAGES_PERSO_MANAGEMENT.STATUS' | translate }}:</strong>
              <div class="flex items-center mt-1">
                <a href="javascript:void(0)"
                  [class]="estActivationBloquee(package) ? 'text-gray-400 cursor-not-allowed' : 'text-red-600 hover:underline'"
                  [matTooltip]="obtenirTooltipActivation(package)"
                  [matTooltipDisabled]="!estActivationBloquee(package)"
                  (click)="estActivationBloquee(package) ? null : togglePackageActivation(package.scormPackageId, package.actif)">
                  {{ package.actif ? ('PACKAGES_PERSO_MANAGEMENT.DEACTIVATE' | translate) :
                  ('PACKAGES_PERSO_MANAGEMENT.ACTIVATE' | translate) }}
                </a>
              </div>
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>